import React from 'react'
import Header from '../../layouts/Header'
import Footer from '../../layouts/Footer'
import KotlinHero from '../../layouts/Technologie/Kotlipage/KotlinHero'
import WhyChooseKotlin from '../../layouts/Technologie/Kotlipage/WhyChooseKotlin'
import BenefitsKotlin from '../../layouts/Technologie/Kotlipage/BenefitsKotlin'
import KotlinFeatures from '../../layouts/Technologie/Kotlipage/KotlinFeatures'
import FinalCTA from '../../layouts/FinalCTA'

const Kotlinpage = () => {
    return (
        <>
            <Header/>
            <KotlinHero/>
            <WhyChooseKotlin/>
            <BenefitsKotlin/>
            <KotlinFeatures/>
            <FinalCTA/>
            <Footer/>
        </>
    )
}

export default Kotlinpage